export default __webpack_public_path__ + "static/media/featured-item-8.8abade27.png";